<script setup>

import Card from "@/Components/Card.vue";
import MaskIcon from "@/Components/MaskIcon.vue";
import {ref} from "vue";

const props = defineProps({
    title: String,
    description: String,
    isBuyer: {
        type: Boolean,
        default: false
    },
    // The offer page has no other visible element carrying the offer's own title, so its
    // "TITLE" row doubles as the page's <h1> instead of a plain <div> - see Offer/Show.vue.
    asHeading: {
        type: Boolean,
        default: false
    },
    // Uppercase suits the short "TITLE" usage (matches the site's all-caps button/heading
    // style), but the "Description" usage can carry long free-form Russian text, which is hard
    // to read in all caps - default true keeps the existing TITLE call sites unchanged.
    descriptionUppercase: {
        type: Boolean,
        default: true
    }
})

const openBlock = ref(false)

const open = () => {
    if (props.isBuyer) {
        openBlock.value = !openBlock.value
    }
}


</script>

<template>
    <card class="p-3 flex flex-col gap-2.5">
        <div class="px-2.5 dark:text-slate-200 text-sm font-medium leading-full uppercase">
            {{ title }}
        </div>
        <div class="flex" :class="{'cursor-pointer': isBuyer}" @click="open">
            <component :is="asHeading ? 'h1' : 'div'"
                 :class="[isBuyer && !openBlock ? 'h-4': 'h-auto', descriptionUppercase ? 'uppercase' : '']"
                 class="dark:text-slate-200 text-sm font-normal leading-120 tracking-wider items-center overflow-hidden whitespace-pre-wrap">
                {{ description }}
            </component>

            <template v-if="isBuyer">
                <MaskIcon src="/assets/icons/arrow.svg" class="w-6 h-6 shrink-0 -mt-1 bg-[#21272A] dark:bg-white"/>
            </template>
        </div>
    </card>
</template>

<style scoped>

</style>
